import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './styles.module.scss';

const NOT_CLOSED = 'not_closed';

const QUALIFICATION_ICON = {
  positive: 'icon-positivo',
  negative: 'icon-negativo',
  neutral: 'icon-neutro',
  without_qualification: 'icon-mostrarmenos',
};

const QUALIFICATION_STYLE = {
  positive: 'positive',
  negative: 'negative',
  neutral: 'neutral',
  without_qualification: 'without_calification',
};

export default function VisitQualificationCell({
  qualification,
  label,
  ...rest
}) {
  if (qualification === NOT_CLOSED || label === '-') {
    return <Text variant="body.fontSize13">-</Text>;
  }

  const styleKey = QUALIFICATION_STYLE[qualification] ?? 'without_calification';
  const icon = QUALIFICATION_ICON[qualification] ?? 'icon-mostrarmenos';

  return (
    <Box
      className={styles.closureReason}
      data-qualification={styleKey}
      {...rest}
    >
      <Icon className={styles.closureReasonIcon} icon={icon} />
      {label && <Text className={styles.closureReasonText}>{label}</Text>}
    </Box>
  );
}
